/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import { CurrentUser } from "./modals/CurrentUser";
import { setAdminlogin } from "./Services/AdminService";
import { IUploadObject } from "./UploadPhotos/UploadPhotos";

export class IBodyshopService {
  apiBaseUrl = "https://flowautobody.azurewebsites.net"; //azure
  // apiBaseUrl = "https://api.flowautobody.com" //aws
  redeemDebtorId = "26554869-8bec-4cde-8206-e9313e6f16a7";
  estimateDetails = {};
  // jobsheetProfiles: jobSheetProfile[] = [];
  // defJobSheeProfile: jobSheetProfile = { id: "", name: "", version: "" };
  // dollarEstimatingProfile: EstimatingProfile = null as any;
  // allEstimatingProfile: EstimatingProfile[] = [];
  // redeemDebtor: Debtor = null as any;
  // allDebtors: Debtor[] = [];
  currentUser: CurrentUser;
  isLinkOpenedFromEmail: boolean = false;
  loggedIn = false;
  jobSelected: any;
  constructor() {
    this.currentUser = JSON.parse(
      localStorage.getItem("currentUser") as any
    ) as any;
  }

  isRedeemedEstimate(debtorId: string) {
    return debtorId == this.redeemDebtorId;
  }

  logout() {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("estimateData");
    setAdminlogin(false);
    this.loggedIn = false;
  }

  getJobSheetProfiles() {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/GetJobSheetProfiles",
      "GET",
      null
    );
  }
 
  getHighResolutionImageUrl(imageId: string) {
    // launch url in browser
    return this.apiBaseUrl + "/api/iBodyShop/Images/" + imageId;
  }
  async getDocument(id: string) {
    return this.apiBaseUrl + "/api/iBodyShop/GetDocument/" + id;
  }

  getUserData(data: any) {
    let local = JSON.parse(data);
    let user;
    if (local) {
      return (user = {
        estimateId: local["Data"],
        expectedArrival: null,
        expectedPickup: null,
        owner: "",
        paintCode: "",
        isAccepted: null,
        isBookingConfirmed: false,
        dropOffDate: null,
        pickUpDate: null,
        isBookingRequested: false,
        emailId: "",
        workingDays: 0,
        primaryDetailId: "",
        isCarBooked: false,
      });
    }
    return null;
  }

  updateReferenceNumber(estimateId: string, refNumber: string) {
    let body = {
      estimateId: estimateId,
      ReferralName: "Referral",
      ReferenceNo: refNumber,
    };
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/UpdateReferral",
      "POST",
      body
    );
  }

  addImagesBase64(images: IUploadObject, category: string) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/iBodyShop/AddImagesBase64/" + category,
      "POST",
      {
        ...images,
      }
    );
  }

  sendRequest(url: string, method: string, data: any) {
    let requestOptions: any = {
      method: method,
      headers: { "Content-Type": "application/json" },
    };
    if (data) {
      requestOptions["body"] = JSON.stringify(data);
    }
    return fetch(url, requestOptions);
  }

  addEstimateFeedback(data: any) {
    return this.sendRequest(
      this.apiBaseUrl + "/api/sharepoint/AddEstimateFeedback",
      "POST",
      data
    );
  }


  async getJobSheet(JobSheetId: string) {
    return await this.sendRequest(
      this.apiBaseUrl + `/api/iBodyShop/api/iBodyShop/JobSheet/${JobSheetId}`,
      "GET",
      null
    ).then(
      async (res: any) => {
        if (res.ok) {
          return await res.json();
        } else {
          return [];
        }
      },
      (error) => {
        return [];
      }
    );
  }
}
